import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const themeContext = useContext(ThemeContext);

  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.02846 20C0.765 20 0.501545 19.8998 0.301379 19.6981C-0.10046 19.2963 -0.10046 18.6448 0.301379 18.243L18.2435 0.301371C18.6453 -0.100457 19.2968 -0.100457 19.6986 0.301371C20.1005 0.7032 20.1005 1.35466 19.6986 1.75674L1.75679 19.6981C1.55511 19.8985 1.29166 20 1.02846 20Z"
        fill={themeContext.colors.font1}
      />
      <path
        d="M18.9718 20C18.7083 20 18.4451 19.8998 18.2447 19.6981L0.301379 1.75674C-0.10046 1.35466 -0.10046 0.7032 0.301379 0.301371C0.703217 -0.100457 1.3547 -0.100457 1.75679 0.301371L19.6986 18.243C20.1005 18.6448 20.1005 19.2963 19.6986 19.6981C19.4969 19.8985 19.2337 20 18.9718 20Z"
        fill={themeContext.colors.font1}
      />
    </Svg>
  );
};

export default Icon;
